import React from "react"

const Svgsprite = props => (
  <svg className={`svg_media ${props.svgclass}`} viewBox={`${props.vbox}`}>
    <use xlinkHref={`#${`${props.name}`}`} />
  </svg>
)

export default Svgsprite
